export enum PlanEditModeEnum {
  None = 1,
  Clipping = 2,
  Edit = 3
}
